import { HttpClient } from '@src/clients/HttpClient.js';
import { createTestBearerToken } from '@src/testing/createTestBearerToken.js';
import { getMicrofrontendClusterName, getMicrofrontendEnvironmentName, isLocalhost } from '@src/utils/environment.js';

export const apiConsentUrl = isLocalhost() ? `http://${window.location.hostname}:3000` : `https://${getMicrofrontendEnvironmentName()}-api-consent.high.coms-${getMicrofrontendClusterName(getMicrofrontendEnvironmentName())}.aws.de.pri.o2.com`;

export const api4pUrl = isLocalhost() ? `http://${window.location.hostname}:3200` : `https://${getMicrofrontendEnvironmentName()}-api-4p.high.coms-${getMicrofrontendClusterName(getMicrofrontendEnvironmentName())}.aws.de.pri.o2.com`;

export class ApiConsentClient extends HttpClient {
  spId: string = 'SP301';
  lcId: string = '4711';

  static async create() {
    const client = new ApiConsentClient({ apiUrl: apiConsentUrl });
    await client.createAccessToken();
    return client;
  }

  setCustomer(spId: string, lcId: string) {
    this.spId = spId;
    this.lcId = lcId;
  }

  async createAccessToken() {
    this.accessToken = await createTestBearerToken({
      username: ['491797250005', 'foo@bar.de'],
      spID: this.spId,
      domainModel: [
        {
          customerAccountId: this.lcId,
          role: 'Owner',
        },
      ],
      scope: ['openid'],
    });
  }
}
